import React from 'react';
// UI
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
// Utils
import { buildTheme } from 'theme';

const SetupLayout = ({ children, themeOverrides = {} }) => (
  <ThemeProvider theme={buildTheme(themeOverrides)}>
    <CssBaseline />
    <Box
      sx={{
        // Fit #root (height:100%), not 100vh — body already applies safe-area padding,
        // and 100vh overflows the clipped root (especially Capacitor iOS / mobile Safari).
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
        // Nested overflow under html/body/#root overflow:hidden needs explicit scroll + touch.
        overflowY: 'scroll',
        WebkitOverflowScrolling: 'touch',
        touchAction: 'pan-y',
        overscrollBehaviorY: 'contain',
        minHeight: 0,
      }}
    >
      {children}
    </Box>
  </ThemeProvider>
);

export default SetupLayout;
